// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__Jfg77","input":"style_input__F7z9N"};